import styled from 'styled-components';
import { config } from '../../../../../Configurations';
import { media } from '../../../../../Utils/mediaQueries';

export const CountdownBackground = styled.div`
    ${props => (!props.isEmbed ? 'position: fixed' : 'position: absolute')};
    // position: absolute;
    top: 0;
    left: ${props => (props.slideIndex ? `calc(100vw * ${props.slideIndex})px` : 0)};
    z-index: 10000;
    width: 100vw;
    height: 100vh;
    background: radial-gradient(circle at 48% 3%, #fb721b, #fd3260);

    display: flex;
    justify-content: center;
    align-items: center;
`;

export const RepeatTimeContainer = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.phone`
        width: 100%;
        height: auto;
        margin: 50px 0;
    `};
`;

export const RepeatInfoContainer = styled.div`
    width: 50%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    ${media.phone`
        width: 100%;
        height: auto;
        margin-top: 50px;
    `};
`;

export const CircleOutline = styled.div`
    width: 35vw;
    height: 35vw;
    border-radius: 1000px;
    background: radial-gradient(circle at 48% 3%, #fb721b, #fd3260);
    margin: 10px;
    padding: 5px;

    ${media.phone`
        width: 60vw;
        height: 60vw;
    `};
`;

export const CircleBody = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 1000px;
    background-color: #0e0e0e;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
`;

export const ExerciseImage = styled.div`
    width: 20vw;
    height: 20vw;
    background-image: url(${props => (props.background ? `${config.baseUrl}/${props.background}` : null)});
    background-size: cover;

    ${media.phone`
        width: 40vw;
        height: 40vw;
    `};
`;

export const RightSideContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Repeat/Content/style.js